export default __webpack_public_path__ + "static/media/powerpoint.b992e5d0.svg";